import * as styles from './loader.module.css';

export default function Loader() {
  return (
    <div class={styles.ldsGrid}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
